import { __extends } from "tslib";
import { Vector3D, AbstractionBase, Matrix3D, ColorTransform, Point, Transform, } from '@awayjs/core';
import { HierarchicalProperty } from '../base/HierarchicalProperty';
import { HeirarchicalEvent } from '../events/HeirarchicalEvent';
import { ContainerEvent } from '../events/ContainerEvent';
import { BlendMode } from '@awayjs/stage';
import { AlignmentMode } from '../base/AlignmentMode';
import { OrientationMode } from '../base/OrientationMode';
import { BasicPartition } from './BasicPartition';
import { ContainerNodeEvent } from '../events/ContainerNodeEvent';
var NodePool = /** @class */ (function () {
    function NodePool(entity, partitionClass) {
        this.id = entity.id;
        this.partitionClass = partitionClass;
    }
    NodePool.getRootNode = function (entity, partitionClass) {
        return entity.getAbstraction(new NodePool(entity, partitionClass));
    };
    NodePool.prototype.getNode = function (entity) {
        return entity.getAbstraction(this);
    };
    NodePool.prototype.requestAbstraction = function (_asset) {
        return ContainerNode;
    };
    return NodePool;
}());
export { NodePool };
/**
 * @class away.partition.ContainerNode
 */
var ContainerNode = /** @class */ (function (_super) {
    __extends(ContainerNode, _super);
    function ContainerNode(container, pool) {
        var _this = _super.call(this, container, pool) || this;
        _this._hierarchicalPropsDirty = HierarchicalProperty.ALL;
        _this._position = new Vector3D();
        _this._matrix3D = new Matrix3D();
        _this._inverseMatrix3DDirty = true;
        _this._orientationMatrix = new Matrix3D();
        _this._tempVector3D = new Vector3D();
        _this._isCacheSource = false;
        _this._cacheAsBitmap = false;
        _this._transformDisabled = false;
        _this._maskId = -1;
        _this._masks = [];
        _this._childNodes = new Array();
        _this._numChildNodes = 0;
        _this._onHierarchicalInvalidate
            = function (event) { return _this.invalidateHierarchicalProperty(event.property); };
        _this._onAddChildAt
            = function (event) { return _this.addChildAt(event.entity, event.index); };
        _this._onRemoveChildAt
            = function (event) { return _this.removeChildAt(event.index); };
        _this._onEntityInvalidate
            = function (event) { return _this.invalidateEntity(event.entity); };
        _this._onEntityClear
            = function (event) { return _this.clearEntity(); };
        _this.container = container;
        _this.container.addEventListener(HeirarchicalEvent.INVALIDATE_PROPERTY, _this._onHierarchicalInvalidate);
        _this.container.addEventListener(ContainerEvent.ADD_CHILD_AT, _this._onAddChildAt);
        _this.container.addEventListener(ContainerEvent.REMOVE_CHILD_AT, _this._onRemoveChildAt);
        _this.container.addEventListener(ContainerEvent.INVALIDATE_ENTITY, _this._onEntityInvalidate);
        _this.container.addEventListener(ContainerEvent.CLEAR_ENTITY, _this._onEntityClear);
        for (var i = 0; i < container.numChildren; ++i)
            _this.addChildAt(container.getChildAt(i), _this._numChildNodes);
        _this._hierarchicalPropsDirty = HierarchicalProperty.ALL;
        _this._activeTransform = _this.container.transform;
        return _this;
    }
    Object.defineProperty(ContainerNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContainerNode.prototype, "partition", {
        get: function () {
            var _a;
            if (!this._partition || this._partitionClass != this.container.partitionClass) {
                this._partitionClass = this.container.partitionClass;
                if (this.parent === this) {
                    throw ('Slef REF!!!');
                }
                this._partition = this.container.partitionClass
                    ? new this.container.partitionClass(this)
                    : ((_a = this._parent) === null || _a === void 0 ? void 0 : _a.partition) || new this._pool.partitionClass(this);
            }
            return this._partition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContainerNode.prototype, "pickObjectNode", {
        get: function () {
            if (this._pickObject != this.container.pickObject) {
                this._pickObject = this.container.pickObject;
                if (this._pickObject) {
                    this._pickObject.partitionClass = BasicPartition;
                    this._pickObjectNode = this._pickObject.getAbstraction(this._pool);
                    if (this._pickObject.pickObjectFromTimeline)
                        this._pickObjectNode.setParent(this);
                }
                else {
                    this._pickObjectNode.setParent(null);
                    this._pickObjectNode = null;
                }
            }
            return this._pickObjectNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContainerNode.prototype, "boundsVisible", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContainerNode.prototype, "pool", {
        get: function () {
            return this._pool;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContainerNode.prototype, "transformDisabled", {
        get: function () {
            return this._transformDisabled;
        },
        set: function (value) {
            if (this._transformDisabled == value)
                return;
            this._transformDisabled = value;
            if (this._transformDisabled) {
                this._activeTransform = ContainerNode._nullTransform;
            }
            else {
                this._activeTransform = this.container.transform;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    ContainerNode.prototype.getPosition = function () {
        if (this._positionDirty) {
            if (this.container._registrationMatrix3D &&
                this.container.alignmentMode === AlignmentMode.REGISTRATION_POINT) {
                this._position.x = -this.container._registrationMatrix3D._rawData[12];
                this._position.y = -this.container._registrationMatrix3D._rawData[13];
                this._position.z = -this.container._registrationMatrix3D._rawData[14];
                this._position = this.getMatrix3D().transformVector(this._position, this._position);
                /*
                this._position.decrementBy(
                    new Vector3D(
                        this._registrationPoint.x*this._scaleX,
                        this._registrationPoint.y*this._scaleY,
                        this._registrationPoint.z*this._scaleZ));
                */
            }
            else {
                this.getMatrix3D().copyColumnTo(3, this._position);
            }
            this._positionDirty = false;
        }
        return this._position;
    };
    /**
     *
     */
    ContainerNode.prototype.getInverseMatrix3D = function () {
        if (this._inverseMatrix3DDirty) {
            if (!this._inverseMatrix3D)
                this._inverseMatrix3D = new Matrix3D();
            this._inverseMatrix3DDirty = false;
            this._inverseMatrix3D.copyFrom(this.getMatrix3D());
            this._inverseMatrix3D.invert();
        }
        return this._inverseMatrix3D || (this._inverseMatrix3D = new Matrix3D());
    };
    ContainerNode.prototype.getMatrix3D = function () {
        if (this._hierarchicalPropsDirty & HierarchicalProperty.SCENE_TRANSFORM) {
            this._matrix3D.copyFrom(this._activeTransform.matrix3D);
            if (this.container._registrationMatrix3D) {
                this._matrix3D.prepend(this.container._registrationMatrix3D);
                if (this.container.alignmentMode != AlignmentMode.REGISTRATION_POINT) {
                    this._matrix3D.appendTranslation(-this.container._registrationMatrix3D._rawData[12] * this._activeTransform.scale.x, -this.container._registrationMatrix3D._rawData[13] * this._activeTransform.scale.y, -this.container._registrationMatrix3D._rawData[14] * this._activeTransform.scale.z);
                }
            }
            if (this._parent)
                this._matrix3D.append(this._parent.getMatrix3D());
            // scrollRect-masks are childs of the object that have the scrollRect applied
            // to support scrolling we need to:
            // 		- move objects with scrollRect by negative scrollRect position
            // 		- move scrollRect-masks by positive scrollRect position
            if (!this.container.maskMode && this.container.scrollRect)
                this._matrix3D.prependTranslation(-this.container.scrollRect.x, -this.container.scrollRect.y, 0);
            else if (this.container.maskMode && this.container.scrollRect)
                this._matrix3D.prependTranslation(this.container.scrollRect.x, this.container.scrollRect.y, 0);
            this._hierarchicalPropsDirty ^= HierarchicalProperty.SCENE_TRANSFORM;
            //TODO: refactor controller API
            if (this.container['_iController'])
                this.container['_iController'].updateController();
        }
        return this._matrix3D;
    };
    /**
     *
     */
    ContainerNode.prototype.getRenderMatrix3D = function (cameraTransform) {
        if (this.container.orientationMode == OrientationMode.CAMERA_PLANE) {
            var comps = cameraTransform.decompose();
            comps[0].copyFrom(this.getPosition());
            comps[3].copyFrom(this._activeTransform.scale);
            this._orientationMatrix.recompose(comps);
            //add in case of registration point
            if (this.container._registrationMatrix3D) {
                this._orientationMatrix.prepend(this.container._registrationMatrix3D);
                if (this.container.alignmentMode != AlignmentMode.REGISTRATION_POINT)
                    this._orientationMatrix.appendTranslation(-this.container._registrationMatrix3D._rawData[12] * this._activeTransform.scale.x, -this.container._registrationMatrix3D._rawData[13] * this._activeTransform.scale.y, -this.container._registrationMatrix3D._rawData[14] * this._activeTransform.scale.z);
            }
            return this._orientationMatrix;
        }
        return this.getMatrix3D();
    };
    ContainerNode.prototype.getColorTransform = function () {
        if (this._hierarchicalPropsDirty & HierarchicalProperty.COLOR_TRANSFORM) {
            if (!this._colorTransform)
                this._colorTransform = new ColorTransform();
            if (this._parent && this._parent.getColorTransform()) {
                this._colorTransform.copyFrom(this._parent.getColorTransform());
                this._colorTransform.prepend(this._activeTransform.colorTransform);
            }
            else {
                this._colorTransform.copyFrom(this._activeTransform.colorTransform);
            }
            if (this.container.blendMode === BlendMode.OVERLAY) {
                // apply 0.5 alpha for object with `overlay` because we not support it now
                this._colorTransform.alphaMultiplier *= 0.5;
            }
            this._hierarchicalPropsDirty ^= HierarchicalProperty.COLOR_TRANSFORM;
        }
        return this._colorTransform || (this._colorTransform = new ColorTransform());
    };
    ContainerNode.prototype.rebuildBitmapCacheFlag = function () {
        if (!(this._hierarchicalPropsDirty & HierarchicalProperty.CACHE_AS_BITMAP)) {
            return;
        }
        // mark that this container is cache source
        this._isCacheSource = this.container.cacheAsBitmap;
        // when subree has cached parent include self
        // parent (self = true, sub = true)
        // -> child (self = false, sub = true)
        // -> child (self = false, sub = true)
        // -> child (self = false, sub = true)
        // this is requred, because need know that current container is cache-source
        if (this._parent) {
            this._cacheAsBitmap = this._isCacheSource || this.parent.getIsCacheAsBitmap();
        }
        this._hierarchicalPropsDirty ^= HierarchicalProperty.CACHE_AS_BITMAP;
    };
    ContainerNode.prototype.getIsCacheSource = function () {
        this.rebuildBitmapCacheFlag();
        return this._isCacheSource;
    };
    ContainerNode.prototype.getIsCacheAsBitmap = function () {
        this.rebuildBitmapCacheFlag();
        return this._cacheAsBitmap;
    };
    /**
     *
     * @returns {number}
     */
    ContainerNode.prototype.getMaskId = function () {
        if (this._hierarchicalPropsDirty & HierarchicalProperty.MASK_ID) {
            this._maskId = (this.container.maskId != -1)
                ? this.container.maskId
                : (this._parent)
                    ? this._parent.getMaskId()
                    : -1;
            this._hierarchicalPropsDirty ^= HierarchicalProperty.MASK_ID;
        }
        return this._maskId;
    };
    ContainerNode.prototype.getMasks = function (update) {
        if (update === void 0) { update = false; }
        if (update) {
            this._masks.length = 0;
            if (this.container.masks)
                for (var i = 0; i < this.container.masks.length; i++)
                    this._masks.push(this._pool.getNode(this.container.masks[i]).partition.rootNode);
        }
        return this._masks;
    };
    ContainerNode.prototype.getMaskOwners = function () {
        var _a;
        if (this._hierarchicalPropsDirty & HierarchicalProperty.MASKS) {
            var masks = this.getMasks(true);
            this._maskOwners = (((_a = this._parent) === null || _a === void 0 ? void 0 : _a.getMaskOwners()) && this.getMaskId() == -1)
                ? masks.length
                    ? this._parent.getMaskOwners().concat([this])
                    : this._parent.getMaskOwners().concat()
                : masks.length
                    ? [this]
                    : null;
            this._hierarchicalPropsDirty ^= HierarchicalProperty.MASKS;
        }
        return this._maskOwners;
    };
    /**
     * Converts the `point` object from the Stage(global) coordinates to the
     * display object's(local) coordinates.
     *
     * To use this method, first create an instance of the Point class. The _x_
     * and _y_ values that you assign represent global coordinates because they
     * relate to the origin(0,0) of the main display area. Then pass the Point
     * instance as the parameter to the `globalToLocal()` method. The method
     * returns a new Point object with _x_ and _y_ values that relate to the
     * origin of the display object instead of the origin of the Stage.
     *
     * @param point An object created with the Point class. The Point object
     *              specifies the _x_ and _y_ coordinates as properties.
     * @return A Point object with coordinates relative to the display object.
     */
    ContainerNode.prototype.globalToLocal = function (point, target) {
        if (target === void 0) { target = null; }
        this._tempVector3D.setTo(point.x, point.y, 0);
        var pos = this.getInverseMatrix3D().transformVector(this._tempVector3D, this._tempVector3D);
        if (!target)
            target = new Point();
        target.x = pos.x;
        target.y = pos.y;
        return target;
    };
    /**
     * Converts a two-dimensional point from the Scene(global) coordinates to a
     * three-dimensional display object's(local) coordinates.
     *
     * <p>To use this method, first create an instance of the Vector3D class. The x,
     * y and z values that you assign to the Vector3D object represent global
     * coordinates because they are relative to the origin(0,0,0) of the scene. Then
     * pass the Vector3D object to the <code>globalToLocal3D()</code> method as the
     * <code>position</code> parameter.
     * The method returns three-dimensional coordinates as a Vector3D object
     * containing <code>x</code>, <code>y</code>, and <code>z</code> values that
     * are relative to the origin of the three-dimensional display object.</p>
     *
     * @param point A Vector3D object representing global x, y and z coordinates in
     *              the scene.
     * @return A Vector3D object with coordinates relative to the three-dimensional
     *         display object.
     */
    ContainerNode.prototype.globalToLocal3D = function (position) {
        return this.getInverseMatrix3D().transformVector(position);
    };
    /**
     * Converts the `point` object from the display object's(local) coordinates
     * to the Stage(global) coordinates.
     *
     * This method allows you to convert any given _x_ and _y_ coordinates from
     * values that are relative to the origin(0,0) of a specific display
     * object(local coordinates) to values that are relative to the origin of
     * the Stage(global coordinates).
     *
     * To use this method, first create an instance of the Point class. The _x_
     * and _y_ values that you assign represent local coordinates because they
     * relate to the origin of the display object.
     *
     * You then pass the Point instance that you created as the parameter to the
     * `localToGlobal()` method. The method returns a new Point object with _x_
     * and _y_ values that relate to the origin of the Stage instead of the
     * origin of the display object.
     *
     * @param point The name or identifier of a point created with the Point
     *              class, specifying the _x_ and _y_ coordinates as properties.
     * @return A Point object with coordinates relative to the Stage.
     */
    ContainerNode.prototype.localToGlobal = function (point, target) {
        if (target === void 0) { target = null; }
        this._tempVector3D.setTo(point.x, point.y, 0);
        var pos = this.getMatrix3D().transformVector(this._tempVector3D, this._tempVector3D);
        if (!target)
            target = new Point();
        target.x = pos.x;
        target.y = pos.y;
        return target;
    };
    ContainerNode.prototype.getBoundsPrimitive = function (pickGroup) {
        return null;
    };
    ContainerNode.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this.container.removeEventListener(HeirarchicalEvent.INVALIDATE_PROPERTY, this._onHierarchicalInvalidate);
        this.container.removeEventListener(ContainerEvent.ADD_CHILD_AT, this._onAddChildAt);
        this.container.removeEventListener(ContainerEvent.REMOVE_CHILD_AT, this._onRemoveChildAt);
        this.container.removeEventListener(ContainerEvent.INVALIDATE_ENTITY, this._onEntityInvalidate);
        this.container.removeEventListener(ContainerEvent.CLEAR_ENTITY, this._onEntityClear);
        if (this._entityNode)
            this.clearEntity();
        for (var i = 0; i < this._numChildNodes; i++)
            this._childNodes[i].onClear(event);
        if (this._pickObject) {
            this._pickObject = null;
            this._pickObjectNode.setParent(null);
            this._pickObjectNode = null;
        }
        this.clear();
    };
    ContainerNode.prototype.onInvalidate = function (event) {
        _super.prototype.onInvalidate.call(this, event);
        if (this.container.isEntity())
            this.invalidateEntity(this.container);
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     * @internal
     */
    ContainerNode.prototype.isInFrustum = function (rootEntity, planes, numPlanes, pickGroup) {
        if (this.isInvisible())
            return false;
        return true;
        //return this.partition.isUpdated || pickGroup.getBoundsPicker(this.partition)._isInFrustumInternal(rootEntity, planes, numPlanes);
    };
    /**
     * @internal
     */
    ContainerNode.prototype.isInvisible = function () {
        var _a;
        if (this._hierarchicalPropsDirty & HierarchicalProperty.VISIBLE) {
            this._invisible = this._transformDisabled
                ? false
                : !this.container.visible || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isInvisible());
            this._hierarchicalPropsDirty ^= HierarchicalProperty.VISIBLE;
        }
        return this._invisible;
    };
    /**
     *
     * @param rayPosition
     * @param rayDirection
     * @returns {boolean}
     */
    ContainerNode.prototype.isIntersectingRay = function (_rootEntity, _rayPosition, _rayDirection, _pickGroup) {
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    ContainerNode.prototype.isRenderable = function () {
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    ContainerNode.prototype.isCastingShadow = function () {
        return true;
    };
    ContainerNode.prototype.dispose = function () {
        this._parent = null;
        this._childNodes = null;
    };
    /**
     * @param traverser
     */
    ContainerNode.prototype.acceptTraverser = function (traverser) {
        if (this.partition.rootNode == this)
            this.partition.updateEntities();
        //get the sub-traverser for the partition, if different, terminate this traversal
        if (traverser.partition != this.partition && traverser != traverser.getTraverser(this.partition))
            return;
        if (!traverser.enterNode(this))
            return;
        if (!this.container.maskMode && this._scrollRect != this.container.scrollRect) {
            this._scrollRect = this.container.scrollRect;
            if (this._scrollRectNode) {
                this._scrollRectNode.setParent(null);
                this._scrollRectNode = null;
            }
            if (this._scrollRect) {
                this._scrollRectNode = this.container.getScrollRectPrimitive()
                    .getAbstraction(this._pool);
                this._scrollRectNode.container.scrollRect = this._scrollRect;
                this._scrollRectNode.setParent(this);
            }
        }
        for (var i = this._numChildNodes - 1; i >= 0; i--)
            this._childNodes[i].acceptTraverser(traverser);
        if (this._entityNode)
            this._entityNode.acceptTraverser(traverser);
    };
    /**
     *
     * @param node
     * @internal
     */
    ContainerNode.prototype.addChildAt = function (entity, index) {
        var node = entity.getAbstraction(this._pool);
        node.setParent(this);
        if (index == this._numChildNodes)
            this._childNodes.push(node);
        else
            this._childNodes.splice(index, 0, node);
        this._numChildNodes++;
        return node;
    };
    /**
     *
     * @param node
     * @internal
     */
    ContainerNode.prototype.removeChildAt = function (index) {
        this._numChildNodes--;
        var node = (index == this._numChildNodes)
            ? this._childNodes.pop()
            : this._childNodes.splice(index, 1)[0];
        node.setParent(null);
        return node;
    };
    ContainerNode.prototype.invalidateEntity = function (entity) {
        if (this._entityNode == null) {
            this._entityNode = entity.getAbstraction(this.partition);
            this._entityNode.setParent(this);
        }
        this._partition.invalidateEntity(this._entityNode);
    };
    ContainerNode.prototype.clearEntity = function () {
        this._partition.clearEntity(this._entityNode);
        this._entityNode.setParent(null);
        this._entityNode = null;
    };
    ContainerNode.prototype.startDrag = function () {
        this._isDragEntity = true;
    };
    ContainerNode.prototype.stopDrag = function () {
        this._isDragEntity = false;
    };
    ContainerNode.prototype.isDragEntity = function () {
        return this._isDragEntity;
    };
    ContainerNode.prototype.isMouseDisabled = function () {
        var _a;
        return !this.container.mouseEnabled || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isMouseChildrenDisabled());
    };
    ContainerNode.prototype.isMouseChildrenDisabled = function () {
        var _a;
        if (this._hierarchicalPropsDirty & HierarchicalProperty.MOUSE_ENABLED) {
            this._mouseChildrenDisabled = !this.container.mouseChildren || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isMouseChildrenDisabled());
            this._hierarchicalPropsDirty ^= HierarchicalProperty.MOUSE_ENABLED;
        }
        return this._mouseChildrenDisabled;
    };
    ContainerNode.prototype.isDescendant = function (node) {
        var parent = this;
        while (parent.parent) {
            parent = parent.parent;
            if (parent == node)
                return true;
        }
        return false;
    };
    ContainerNode.prototype.isAncestor = function (node) {
        return node.isDescendant(this);
    };
    ContainerNode.prototype.invalidateHierarchicalProperty = function (property) {
        var propertyDirty = (this._hierarchicalPropsDirty ^ property) & property;
        if (!propertyDirty)
            return;
        this._hierarchicalPropsDirty |= propertyDirty;
        for (var i = 0; i < this._childNodes.length; ++i)
            this._childNodes[i].invalidateHierarchicalProperty(property);
        if (this._pickObjectNode)
            this._pickObjectNode.invalidateHierarchicalProperty(property);
        if (propertyDirty & HierarchicalProperty.CACHE_AS_BITMAP) {
            if (this.container.isEntity())
                this.invalidateEntity(this.container);
        }
        if (propertyDirty & HierarchicalProperty.SCENE_TRANSFORM) {
            this._positionDirty = true;
            this._inverseMatrix3DDirty = true;
            this.dispatchEvent(this._invalidateMatrix3DEvent
                || (this._invalidateMatrix3DEvent = new ContainerNodeEvent(ContainerNodeEvent.INVALIDATE_MATRIX3D)));
            if (this.container.isEntity())
                this.invalidateEntity(this.container);
        }
    };
    ContainerNode.prototype.setParent = function (parent) {
        if (this._parent) {
            if (this._parent.partition != this.partition)
                this._parent.partition.removeChild(this.partition);
            this.clear();
        }
        this._parent = parent;
        if (this._parent) {
            if (this._parent.partition != this.partition)
                this._parent.partition.addChild(this.partition);
            if (this.container.isEntity())
                this.invalidateEntity(this.container);
        }
        this.invalidateHierarchicalProperty(HierarchicalProperty.ALL);
    };
    ContainerNode._nullTransform = new Transform();
    return ContainerNode;
}(AbstractionBase));
export { ContainerNode };
